import { useQuery } from '@tanstack/react-query';

const INSTANCES_ENDPOINT =
	'https://us-central1-euneos-prod.cloudfunctions.net/api/courses/instances';

/**
 * Fetch recipes with pagination and search
 * @param {object} options
 * @param {boolean} options.hydrate - Hydrate courses with instances and categories
 * @returns {object}
 */
function useLocations() {
	const { isPending, isError, data, error } = useQuery({
		queryKey: ['locations'],
		queryFn: async () => {
			const response = await fetch(INSTANCES_ENDPOINT);

			const data = await response.json();

			const venues = [];
			const countries = [];

			data.forEach((course) => {
				// Remove CONFIRMED and FULL from venue
				if (course.venue.includes('CONFIRMED ')) {
					course.venue = course.venue
						.replace('CONFIRMED ', '')
						.trim();
				}

				if (course.venue.includes('FULL ')) {
					course.venue = course.venue.replace('FULL ', '').trim();
				}

				const split = course.venue.split(',');

				if (split.length < 2) {
					return;
				}

				const tVenue = split[0].trim();
				const tCountry = split[1].trim();

				if (!venues.includes(tVenue)) {
					venues.push(tVenue);
				}

				if (!countries.includes(tCountry)) {
					countries.push(tCountry);
				}
			});

			return {
				venues,
				countries,
			};
		},
	});

	return {
		data,
		error,
		isError,
		isPending,
	};
}

export { useLocations };
